export const SIDEBAR_NAV_MODES = {
  old: 'old',
  new: 'new'
}

export const SIDEBAR_NAV_MODE_STORAGE_KEY = 'sidebar-nav-mode'
export const SIDEBAR_NAV_MODE_CHANGE_EVENT = 'sidebar-nav-mode-changed'

export function readStoredSidebarNavMode() {
  try {
    const stored = window.localStorage.getItem(SIDEBAR_NAV_MODE_STORAGE_KEY)

    if (stored === SIDEBAR_NAV_MODES.old || stored === SIDEBAR_NAV_MODES.new) {
      return stored
    }
  } catch {
    return SIDEBAR_NAV_MODES.old
  }

  return SIDEBAR_NAV_MODES.old
}

export function writeStoredSidebarNavMode(navMode) {
  if (navMode !== SIDEBAR_NAV_MODES.old && navMode !== SIDEBAR_NAV_MODES.new) {
    return
  }

  try {
    window.localStorage.setItem(SIDEBAR_NAV_MODE_STORAGE_KEY, navMode)
  } catch {
    // Ignore storage failures and keep in-memory state.
  }
}

export function setSidebarNavMode(navMode) {
  writeStoredSidebarNavMode(navMode)
  window.dispatchEvent(
    new CustomEvent(SIDEBAR_NAV_MODE_CHANGE_EVENT, { detail: navMode })
  )
}
